import React, {
    forwardRef,
    useImperativeHandle, useState, useEffect
} from 'react';

import Web3 from 'web3';

import config from '../../lib/config';

import { BurnField, checkOtherPlatformDetais1155 } from '../../actions/v1/token';
import { toast } from 'react-toastify';
import SINGLE from '../../ABI/SINGLE.json'
import MULTIPLE from '../../ABI/MULTIPLE.json'
import { getReceipt } from '../../actions/v1/getReceiptFunc';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { network } from "../../views/network"
import { connectWallet, WalletConnect } from '../../views/hooks/useWallet';
import { Account_Connect, Account_disConnect } from "../../actions/redux/action";
import { UserCheck } from '../../actions/v1/user';
import Market from "../../ABI/market"
import { signMessage } from '../../actions/contractProvider';
import { constantContractMethods } from '../hooks/useParamsforSign';
import { NumberChange, NumberOnly } from '../../lib/common';


// toast.configure();
let toasterOption = config.toasterOption;

export const BurnRef = forwardRef((props, ref) => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const Wallet_Details = useSelector(state => state.wallet_connect_context);
    const [burnLoading, setBurnLoading] = useState('init');
    const [burnError, setburnError] = useState('');

    const [ValidateError, Set_ValidateError] = useState({});
    const [Items, Set_Items] = useState({})
    const [noofitems, setnoofitem] = useState(0)
    const [MyTokenDetail, set_MyTokenDetail] = useState({});
    const [currentOwnerAvailableBalance, setCurrentOwnerAvailableBalance] = useState(0);


    useImperativeHandle(
        ref,
        () => ({
            async Burn_Click(item, MyTokenDetail) {
                let useractive = await UserCheck({ currAddr: Wallet_Details?.UserAccountAddr });
                if (useractive?.userValue?.activate) {

                }
                else {
                    toast.error("User banned by the admin")
                    return false;
                }
                let chainid = item?.tokenowners_current?.[0]?.SelectedNetwork || item?.tokenowners_current?.SelectedNetwork
                let accountDetailsss = ''
                

                if (Wallet_Details.networkConfiguration.Chainid == item.tokenowners_current[0].SelectedNetwork) {
                    accountDetailsss = true
                }
                else {
                    
                    accountDetailsss = await switchNetwork(chainid)
                }
                // setTimeout(async() => {
                
                if (chainid === Wallet_Details.networkConfiguration.Chainid) {
                    
                    if (Wallet_Details.UserAccountAddr !== "") {
                        let web3 = new Web3(Wallet_Details.providerss)
                        let data = {
                            Singleaddress: Wallet_Details.networkConfiguration.singleContract,
                            multipleContract: Wallet_Details.networkConfiguration.multipleContract
                        }
                        let CoursetroContract = new web3.eth.Contract(
                            Market,
                            Wallet_Details.networkConfiguration.TradeContract,
                        );
                        let balance = await checkOtherPlatformDetais1155(item, MyTokenDetail, item.type, web3, data, CoursetroContract);
                        
                        if (balance === 0) {
                            toast.warning("You won't buy at this moment please refresh you data", toasterOption);
                            setTimeout(() => {
                                navigate("/")
                            }, 1000);
                            return false;
                        }
                        else {

                            props.Set_HitItem(item);
                            Set_Items(item)
                            // setnoofitem(MyTokenDetail.balance)
                            setnoofitem('')
                            set_MyTokenDetail(MyTokenDetail);
                            setCurrentOwnerAvailableBalance(((NumberChange(MyTokenDetail?.balance)-NumberChange(MyTokenDetail?.ListedQuantity))>0)?(NumberChange(MyTokenDetail?.balance)-NumberChange(MyTokenDetail?.ListedQuantity)):0)
                            Set_ValidateError({});
                            window.$('#burn_token_modal').modal('show');
                        }
                    }
                    else {
                        window.$('#connect_modal').modal('show');
                    }
                }
            }
        }),
    )

    async function switchNetwork(configdata) {
        let type = ""
        let networkConfiguration = {}
        let accountDetails;
        if (configdata) {
            if (localStorage.walletConnectType && localStorage.walletConnectType != null && localStorage.walletConnectType == 'MetaMask') {

                type = "MetaMask"
            }
            else if (localStorage.walletConnectType && localStorage.walletConnectType == 'WalletConnect' && localStorage.walletConnectType != null) {
                type = "WalletConnect"
            }

            window.$('#connect_modal').modal('hide');
            
            accountDetails = await connectWallet(type, configdata)
            
            //  const id=toast.loading("Wallet Connecting...")
            let web3 = new Web3(window.ethereum);
            
            if (window.ethereum.isMetaMask == true) {
                const chainId = await web3.eth.getChainId();
                

                if (chainId === network.ETH.Chainid) {
                    networkConfiguration = network.ETH
                }
                else if (chainId === network.BSC.Chainid) {
                    networkConfiguration = network.BSC
                }
            }
            // setPriceoption()

            if (accountDetails != '') {
                
                dispatch({
                    type: Account_Connect,
                    Account_Detail: {
                        UserAccountAddr: accountDetails.accountAddress,
                        UserAccountBal: accountDetails.coinBalance,
                        WalletConnected: "true",
                        Wen_Bln: accountDetails.tokenBalance,
                        Accounts: accountDetails.accountAddress,
                        providerss: accountDetails.web3._provider,
                        networkConfiguration: networkConfiguration
                    }
                })
            }
        }
        return accountDetails
    }

    async function FormSubmit(data, MyTokenDetail) {
        
        let receipt = null;
        let handle = null;

        let chekValidation = validate();
        if (chekValidation) {
            if (Wallet_Details.UserAccountBal < 0) {
                toast.error('Enter vaid balance');
                return false;
            }
            if (Wallet_Details.providerss) {
                let web3 = new Web3(Wallet_Details.providerss)
                if (web3) {
                    let signData = {
                        NFTId: data.tokenCounts,
                        NFTOwner: Wallet_Details.UserAccountAddr,
                    };

                    let signMsg = await signMessage(
                        Wallet_Details.providerss,
                        Wallet_Details?.UserAccountAddr,
                        constantContractMethods?.["burn"],
                        signData,
                        Wallet_Details.networkConfiguration.Chainid,
                        Wallet_Details.networkConfiguration.TradeContract
                    );

                    if (!signMsg.hash) {
                        return toast.error("Try again...", toasterOption);
                    }

                    signData = {
                        ...signData,
                        type: constantContractMethods?.["burn"],
                        signature: signMsg.hash,
                        ContractAddress: Wallet_Details.networkConfiguration.TradeContract,
                        salt: signMsg.salt,
                        nonce: signMsg.nonce,
                        deadline: signMsg.deadline,
                        chainId: Wallet_Details.networkConfiguration.Chainid,
                    };

                    setBurnLoading('processing');
                    let CoursetroContract = null;
                    let contractCall = null;
                    try {
                        if (Items.type === 721) {
                            let CoursetroContract = new web3.eth.Contract(
                                SINGLE,
                                Items.contractAddress
                            );
                            await CoursetroContract.methods
                                .burnNFT(
                                    data.tokenCounts
                                )
                                .send({ from: Wallet_Details.UserAccountAddr })
                                .on('transactionHash', async (transactionHash) => {
                                    // handle = setInterval(async () => {
                                    receipt = await getReceipt(web3, transactionHash)
                                    clr1();
                                    //   }, 8000)
                                })
                        }
                        else if (Items.type === 1155 || Items.type === 11551) {
                           
                            let CoursetroContract = new web3.eth.Contract(
                                MULTIPLE,
                                Items.contractAddress
                            );
                            await CoursetroContract.methods
                                .burnNFT(data.tokenCounts, noofitems)
                                .send({ from: Wallet_Details.UserAccountAddr })
                                .on('transactionHash', async (transactionHash) => {
                                    // handle = setInterval(async () => {
                                    
                                    receipt = await getReceipt(web3, transactionHash)
                                    
                                    clr1();
                                    // }, 8000)
                                })
                        }
                    }
                    catch (error) {
                        setBurnLoading('try');
                        console.error('error : ', error);
                        toast.error('Order not placed', toasterOption)
                    }
                    async function clr1() {
                        if (receipt != null) {
                            clearInterval(handle);
                            if (receipt.status === true) {
                                let postData = {
                                    tokenOwner: Wallet_Details.UserAccountAddr,
                                    tokenCounts: data.tokenCounts,
                                    blockHash: receipt.blockHash,
                                    transactionHash: receipt.transactionHash,
                                    contractAddress: data.contractAddress,
                                    type: data.type,
                                    balance: noofitems,
                                    currAddr: Wallet_Details.UserAccountAddr,
                                    quant: MyTokenDetail.balance,
                                    signData
                                }
                                setBurnLoading('done');
                                let updateBurnField = await BurnField(postData)
                                if (updateBurnField) {
                                    toast.success('Burned successfully', toasterOption)
                                    document.getElementById('closeburn').click()
                                    props.GetUpdatas();
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    let {
        UserAccountAddr,
    } = props;

    useEffect(() => {
        Set_ValidateError({});
    }, []);


    const inputChange = (e) => {
        setburnError('')
        if (e.target && (e.target.value||e.target.value=='')){
            setnoofitem(NumberOnly(e.target.value))
            setBurnLoading('init');
        }
    }

    const SettoInitalValueFuc = () => {
        setBurnLoading('empty');
        setburnError('');
        Set_Items({});
        setnoofitem(0);
        set_MyTokenDetail({});
        setCurrentOwnerAvailableBalance(0);
    }

    const validate = () => {
        
        if (currentOwnerAvailableBalance >= noofitems && NumberChange(noofitems) !== 0) {
            return true;
        }
        else if (noofitems === "") {
            setBurnLoading('empty');
            setburnError("empty")
            return false;
        }
        else if (noofitems === undefined) {
            setBurnLoading('empty');
            setburnError("empty")
            return false;
        }
        else if (NumberChange(noofitems) === 0) {
            setBurnLoading('zero');
            setburnError('zero');
            return false;
        }
        else {
            setBurnLoading('errors');
            setburnError("errors")
            return false;
        }
    }



    return (

        <div className="modal fade primary_modal" id="burn_token_modal" tabIndex="-1" role="dialog" aria-labelledby="burn_token_modalCenteredLabel" aria-hidden="true" data-bs-backdrop="static" data-keyboard="false">
            <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                <div className="modal-content">
                    <div className="modal-header text-center">
                        <h5 className="modal-title" id="burn_token_modalLabel">Burn token</h5>

                        <button type="button" id="closeburn" className="close" data-bs-dismiss="modal" aria-label="Close"

                            disabled={(burnLoading === 'processing')}
                            onClick={() => SettoInitalValueFuc()}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body px-0">
                        <div className="bid_form">
                            <div className="px-4">
                                <p className="checkout_text_light_white text-center" style={{ color: 'black', fontWeight: 'bold' }}>{currentOwnerAvailableBalance} Tokens Available</p>
                            </div>
                            <div className="px-4">
                                <p className="checkout_text_light_white" style={{ color: 'black' }}>Are you sure to burn this token? This action cannot be undone. Token will be transfered to zero address</p>
                            </div>
                            <div className="px-4 mt-2 pt-2">
                                <input
                                    id="burn"
                                    name="burn"
                                    className="form-control"
                                    onChange={(e) => { inputChange(e) }}
                                    value={noofitems}
                                />
                                {
                                    burnError === 'errors' && <span className="text-danger">Check Balance</span> ||
                                    burnError === 'zero' && <span className="text-danger">Qty can't be Zero</span> ||
                                    burnError === 'empty' && <span className="text-danger">Qty can't be Empty"</span>
                                }

                                <div className="text-center mt-3">
                                    <button
                                        type='button'
                                        className="burn_btn_red primary_btn btn-block"
                                        onClick={(() => FormSubmit(Items, MyTokenDetail))}
                                        disabled={(burnLoading === 'done' || burnLoading === 'processing' || burnLoading === 'zero' || burnLoading === 'errors' || burnLoading === 'empty')}
                                    >
                                        {burnLoading === 'processing' && <i className="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >}
                                        {burnLoading === 'init' && 'Continue'}
                                        {burnLoading === 'processing' && 'In-progress...'}
                                        {burnLoading === 'done' && 'Done'}
                                        {burnLoading === 'try' && 'Try Again'}
                                        {burnLoading === 'errors' && 'Try Again'}
                                        {burnLoading === 'zero' && 'Try Again'}
                                        {burnLoading === 'empty' && 'Try Again'}

                                    </button>

                                    <button 
                                        type='button'
                                        className="btn_outline_grey cancel_btn btn-block" 
                                        data-bs-dismiss="modal" 
                                        aria-label="Close" 
                                        onClick={() => SettoInitalValueFuc()}
                                        disabled={burnLoading === 'processing'}
                                    >
                                        Cancel
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

